export const ZoomFactorUtils = {
  calcNativeToDisplayZoomLevel(conversionFactor: number, nativeZoomLevel: number) {
    return nativeZoomLevel * conversionFactor;
  },
  calcDisplayToNativeZoomLevel(conversionFactor: number, displayZoomLevel: number) {
    return displayZoomLevel / conversionFactor;
  },
} as const;
